import api from './client';

// Sprint 2.8 T3-A — branch (şube) API client. Backend: /api/branches (T2).
// Mevcut api/*.js pattern'i (vehicles.js): (args) => api.method(path).then(r => r.data)

export const listBranches = (params) => api.get('/branches', { params }).then(r => r.data);
export const getBranch = (id) => api.get(`/branches/${id}`).then(r => r.data);
export const createBranch = (data) => api.post('/branches', data).then(r => r.data);
export const updateBranch = (id, data) => api.patch(`/branches/${id}`, data).then(r => r.data);
export const deleteBranch = (id) => api.delete(`/branches/${id}`).then(r => r.data);
export const restoreBranch = (id) => api.post(`/branches/${id}/restore`).then(r => r.data);
export const setDefaultBranch = (id) => api.post(`/branches/${id}/set-default`).then(r => r.data);
